import { AfterViewInit, Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CalendarSize, KfbsFullCalendarComponent } from 'kfbs-nglib';
import { Observable } from 'rxjs';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { CalendarService, ResourcesCalendar } from '../../services/calendar.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    standalone: false
})
export class CalendarComponent implements OnInit, OnDestroy, IWidgetComponent, AfterViewInit {
    public data: Widget;
    displayCalendar: boolean = false;
    currentWidgetSize: number;
    calView: string = 'fullWeek';
    public calendarEvent$: Observable<any>;
    public calendarSize: CalendarSize;
    //calendar settings
    public resourcesCalendar: ResourcesCalendar;
    public currentTitle: string = undefined;
    public datePicker: NgbDateStruct;

    @ViewChild('calendarWidget') calWidget: KfbsFullCalendarComponent

    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();
        //  The calendar should always be full sized when viewed through the chromeless page or a modal from the new UI        
        if (this.data.IsChromeless || this.data.IsModal )
            widgetSize += ' widget-large';
        else {
            switch (this.data.Size) {
                case 4: {
                    widgetSize += ' widget-small';
                    break;
                }
                case 6: {
                    widgetSize += ' widget-medium';
                    break;
                }
                case 12: {
                    widgetSize += ' widget-large';
                    break;
                }
            }
        }

        this.calendarSize = ((this.data.Size <= 6) &&
            ((!this.data.IsChromeless) && (!this.data.IsModal))) ? CalendarSize.mobile : CalendarSize.default;
        return widgetSize;
    }

    constructor(
        private logger: LoggerService,        
        public calendar: CalendarService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.Calendar, category);
    }

    ngOnInit() {
        this.resourcesCalendar = ResourcesCalendar.getInstance();
        //calendarEvent$ is only triggered on a button click
        this.resourcesCalendar.calendarEvent$
            .subscribe(
                (event) => {
                    if (this.calWidget)
                        this.calWidget.options.eventSources = event;
                })
        this.log("ngOnInit", null, LogCategory.Init);

        //Teams Hackathon 2021
        //if (this.data.IsChromeless) {
        //    this.resourcesCalendar.titleFormat = { year: 'numeric', month: 'long' };
        //    this.resourcesCalendar.dayHeaderFormat = { day: 'numeric', weekday: 'long' };
        //}
        if (this.data.IsChromeless) {
            this.resourcesCalendar.defaultHeader.right = "";
            this.resourcesCalendar.mobileHeader.right = "";
        }
    }

    ngAfterViewInit() {      
        if (!this.displayCalendar)
            this.displayCalendar = !this.data.IsCollapsed;

        // Set the initial display date for the title.  We can't get it from the API yet because it's still returning in an async but the calendar should always load
        // up on the current day or week.
        var today = new Date();

        //  Leaving hackathon items commented out in case we revisit this functionality
        //if (this.calView == 'singleDay')
        //    this.currentTitle = today.toLocaleString('en-US', { month: 'long', year: 'numeric' });

        //else {
            var start = new Date();
            var end = new Date();
            start.setDate(today.getDate() - (today.getDay()));
            end.setDate(start.getDate() + 6);

            //// workWeek excludes weekends so we want to match the display functionality in Teams for this.
            //if (this.calView == 'workWeek') {
            //    start.setDate(start.getDate() + 1);
            //    end.setDate(end.getDate() - 1);
            //}

            this.currentTitle = start.toLocaleString('en-US', { month: 'long', year: 'numeric' });

            if (start.getMonth() != end.getMonth())
            this.currentTitle = start.toLocaleString('en-US', { month: 'long' }) + ' - ' + end.toLocaleString('en-US', { month: 'long', year: 'numeric' });
        //}
    }

    ngOnDestroy() {        
        this.log("ngOnDestroy", "", LogCategory.Destroy);
        // Fix for popovers remaining open from Calendar when closed.  It is ignored automatically
        // if this is not a calendar or there are no popovers open.
        if (this.calWidget)
            this.calWidget.closePopovers();
    }

    onResize(size: number) {
        var calendarSize = (size <= 6) ? CalendarSize.mobile : CalendarSize.default;
        if (this.calWidget)
            this.calWidget.resize(calendarSize);
    }

    onCollapse(isCollapsed: boolean) {        
        setTimeout(() => { this.displayCalendar = !isCollapsed });
    }

    changeDate(date) {
        this.calWidget.closePopovers();
        if(this.datePicker != undefined)
            this.datePicker.month = this.datePicker.month - 1;

        switch (date) {
            case "next":
                this.calWidget.api.next();
                break;
            case "prev":
                this.calWidget.api.prev();
                break;
            case "today":
                this.calWidget.api.today();
                break;
            case "jump":
                var jumpDate = new Date().setFullYear(this.datePicker.year, this.datePicker.month, this.datePicker.day);
                this.calWidget.api.gotoDate(jumpDate);
                break;
        }

        this.currentTitle = this.calWidget.api.getCurrentData().viewTitle;
    }

    changeView(view) {
        this.calView = view;

        this.calWidget.api.setOption("weekends", true);

        if (view == 'workWeek')
            this.calWidget.api.setOption("weekends", false);

        this.calWidget.api.changeView(view);
    }

    startOfWeek(date) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 0);

        return new Date(date.setDate(diff));
    }

}
